import AnalysisNavigation from '../pages/management/analysis/AnalysisNavigation';
import React from 'react';
import { Link, NavLink, Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import '../styles/scss/financeWorkspace.scss';

const pages = [
  {to:'/management/rents',label:'家賃・スタジオ代',permission:'rents'},
  {to:'/management/kizugawa-analytics',label:'木津川校 月次分析',permission:'finance'},
  {to:'/management/cashflow',label:'資金繰り',permission:'finance'},
];

export default function FinanceWorkspace({permission,children}) {
  const {isLoggedIn,financePermissions,financePermissionsStatus} = useAuth();
  if (!isLoggedIn) return <Navigate to="/login" replace/>;
  const allowed = financePermissionsStatus === 'ready' && financePermissions?.[permission] === true;
  return <div className="finance-workspace">
    <header className="finance-workspace-header">
      <div className="finance-workspace-brand">SLASH <span>FINANCE</span></div>
      <Link className="finance-workspace-back" to="/">管理画面に戻る</Link>
      <nav aria-label="財務ページ">{pages.filter(page=>financePermissions?.[page.permission]===true).map(page=><NavLink key={page.to} to={page.to}>{page.label}</NavLink>)}</nav>
    </header>
    <main className="finance-workspace-main"><div className="inner">
      {allowed ? <><AnalysisNavigation/>{children}</> : <div className="finance-workspace-access">
        {financePermissionsStatus === 'loading' ? <p role="status">利用権限を確認しています…</p> : <>
          <p role="alert">{financePermissionsStatus === 'error' ? '認証・権限を確認できませんでした。再ログインしてください。' : 'このページを利用する権限がありません。'}</p>
          <Link to="/login">ログイン画面へ</Link>
        </>}
      </div>}
    </div></main>
  </div>;
}
